import * as React from 'react';
import { History } from 'history';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { HotelBedData, CMS } from '../shared/index';
import { SESSION_STORAGE_SATTLEMENT_BOOKING_DATA, BHAM_STORAGE_AFFILIATE, BHAM_STORAGE_WISHLIST } from '../core/index';
import { isNull, momentWrapper, getAjaxhelper, makeIsoDate } from '../utils/index';
import { requestToken } from '../utils/request-token';
import { scrollToTop } from '../core/index';
// import moment = require('moment');
// import * as moment from 'moment';
export interface HotelSattlementEnquiryProps extends BaseComponentProps {
    history: History;
}
export interface HotelSattlementEnquiryState extends BaseComponentState {
    name: string;
    email: string;
    address: string;
    country: string;
    phone: string;

    rates: HotelBedData.Rate[];
    hotelCode: number | any;
    hotelName: string | any;
    hotel: HotelBedData.Hotel;
    checkIn: string;
    checkOut: string;
    bulan: number;

    postData: any;
    occupancies: any;
    token: string | any;
    couponCode: string;
}
export class HotelSattlementEnquiry extends BaseComponent<HotelSattlementEnquiryProps, HotelSattlementEnquiryState> {

    // roomBook: any[];
    constructor(props: HotelSattlementEnquiryProps) {
        super(props);
        let ses = sessionStorage.getItem(SESSION_STORAGE_SATTLEMENT_BOOKING_DATA);
        let bulan = 0;
        let rates: HotelBedData.Rate[];
        let hotel: HotelBedData.Hotel;
        let checkIn: string;
        let checkOut: string;
        let occupancies: any;
        if (!isNull(ses)) {
            let seas = JSON.parse(ses as string);
            bulan = seas.bulan;
            checkIn = momentWrapper(seas.initialFilter.stay.checkIn);
            checkOut = momentWrapper(seas.initialFilter.stay.checkOut);
            hotel = seas.hotelData;
            rates = seas.rates;
            occupancies = seas.initialFilter.occupancies;
        }

        this.state = {
            postData: null,
            name: '',
            email: '',
            address: '',
            country: '',
            phone: '',

            rates: rates!,
            hotelCode: hotel!.code,
            hotelName: hotel!.name,
            hotel: hotel!,
            checkIn: checkIn!,
            checkOut: checkOut!,
            bulan: bulan,
            occupancies: occupancies,
            token: null,
            couponCode: ""
        };
    }

    getToken: () => any = () => {
        requestToken().then(d => {
            this.setState({ token: d });
        }).catch(exc => {
            console.log(exc);
        });
    }

    componentWillMount() {
        scrollToTop();
        this.getToken();
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        let roomBook = [];
        for (let room of this.state.hotel.rooms!) {
            for (let rate of room.rates!) {
                for (let rateSelect of this.state.rates) {
                    if (rate.rateKey === rateSelect.rateKey) {

                        roomBook.push({
                            name: room.name,
                            board: rateSelect.boardName

                        });

                    }

                }

            }
        }
        let roomDetail = [];

        for (let roombk of roomBook) {
            roomDetail.push(
                <p> {roombk.name} ({roombk.board})</p>
            );
        }
        let occupancies = [];
        let roomNo = 0;
        for (let occupancie of this.state.occupancies) {
            roomNo++;
            occupancies.push(
                <p>Room {roomNo}, Number of adults: {occupancie.adults}, Number of children: {occupancie.children}  </p>
            );
        }
        return (
            <section className=""  >
                <div style={{ paddingTop: 150, paddingBottom: 20, background: '#373839' }}>
                    <h1 className="center" style={{ color: "white" }}>$1 Holiday Deposit Sale – Book Your Room Today For $1 Deposit – Pay 2 Weeks Before You Arrive</h1>
                </div>
                <div className='container'>
                    <div className="col-md-9" style={{ marginTop: 15, background: '#fff', border: '1px solid #eee', padding: 15 }}>
                        <form id="contactForm" onSubmit={this.submitForm}>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div className=" ">
                                        <label className='col-md-2'> Booking Date </label>
                                        <div className="col-md-10">  {momentWrapper(this.state.checkIn).format("MMM Do YYYY")} -  {momentWrapper(this.state.checkOut).format("MMM Do YYYY")} </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div className=" ">
                                        <label className='col-md-2'> Hotel </label>
                                        <div className="col-md-10">
                                            <strong>{this.state.hotel.name} </strong><br />
                                            {this.state.hotel.address}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div className=" ">
                                        <label className='col-md-2'> Room Detail </label>
                                        <div className="col-md-10">
                                            {roomDetail}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div className=" ">
                                        <label className='col-md-2'> Occupancies </label>
                                        <div className="col-md-10">
                                            {occupancies}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div className=" ">
                                        <label className='col-md-2'> Payment Plan </label>
                                        <div className="col-md-10">
                                            <strong>Deposit and Balance 14 days before arrival</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div className=" ">
                                        <label className='col-md-2'> Name </label>
                                        <div className="col-md-10">
                                            <input
                                                onChange={evt => {
                                                    console.log(evt.target.value);
                                                    let val: string = evt.target.value;
                                                    this.setStateHelper(st => {
                                                        st.name = val;
                                                    });
                                                }}
                                                required={true}
                                                className="form-control "
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div >
                                        <label className='col-md-2'> Email <span className="symbol required" /> </label>
                                        <div className="col-md-10">
                                            <input
                                                onChange={evt => {
                                                    console.log(evt.target.value);
                                                    let val: string = evt.target.value;
                                                    this.setStateHelper(st => {
                                                        st.email = val;
                                                    });
                                                }}
                                                required={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div >
                                        <label className='col-md-2'> Phone <span className="symbol required" /> </label>
                                        <div className="col-md-10">
                                            <input
                                                onChange={evt => {
                                                    console.log(evt.target.value);
                                                    let val: string = evt.target.value;
                                                    this.setStateHelper(st => {
                                                        st.phone = val;
                                                    });
                                                }}
                                                required={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div >
                                        <label className='col-md-2'> Address <span className="symbol required" /> </label>
                                        <div className="col-md-10">
                                            <input
                                                onChange={evt => {
                                                    console.log(evt.target.value);
                                                    let val: string = evt.target.value;
                                                    this.setStateHelper(st => {
                                                        st.address = val;
                                                    });
                                                }}
                                                required={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div  >
                                        <label className="col-md-2"> Country <span className="symbol required" /> </label>
                                        <div className="col-md-10">
                                            <input
                                                onChange={evt => {
                                                    console.log(evt.target.value);
                                                    let val: string = evt.target.value;
                                                    this.setStateHelper(st => {
                                                        st.country = val;
                                                    });
                                                }}
                                                required={true}
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="form-group">
                                    <div  >
                                        <label className="col-md-2"> Coupon Code   </label>
                                        <div className="col-md-10">
                                            <input
                                                onChange={evt => {
                                                    console.log(evt.target.value);
                                                    let val: string = evt.target.value;
                                                    this.setStateHelper(st => {
                                                        st.couponCode = val;
                                                    });
                                                }} 
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="col-md-12">
                                    <button data-caption-delay="900" className="btn btn-primary " type="submit">
                                        <span>Enquire Now</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        );
    }

    submitForm: (evt: any) => any = (evt: any) => {
        let affCode = localStorage.getItem(BHAM_STORAGE_AFFILIATE);
        let whCode = sessionStorage.getItem(BHAM_STORAGE_WISHLIST);
        let checkIn  =  this.state.checkIn as any;
        let checkOut =  this.state.checkOut as any;
        if ( typeof checkIn !== "string" ) {
            // heckIn = momentWrapper(checkIn).fomat("MM-DD-YYYY")  ;
            checkIn = makeIsoDate(new Date(checkIn));  
        }
        if ( typeof checkOut !== "string" ) {
            checkOut =  makeIsoDate(new Date(checkOut));
        }
        evt.preventDefault();
        let postData: CMS.CmsSettlementEnquiry = {
            name: this.state.name,
            email: this.state.email,
            address: this.state.address,
            checkIn: checkIn as any,
            checkOut: checkOut as any,
            phoneNumber: this.state.phone,
            country: this.state.country,
            hotelCode: this.state.hotelCode,
            hotelName: this.state.hotelName,
            settlement: this.state.bulan,
            rates: JSON.stringify(this.state.rates),
            couponCode: this.state.couponCode,
            affiliateCode: !affCode ? '' : affCode,
            wishlistCode: !whCode ? '' : whCode 
        };
        getAjaxhelper().put(`/dynamics/bham-api/settlement`, { data: postData, token: this.state.token }).then(
            d => {
                console.log(d);
                let roomBook = [];
                for (let room of this.state.hotel.rooms!) {
                    for (let rate of room.rates!) {
                        for (let rateSelect of this.state.rates) {
                            if (rate.rateKey === rateSelect.rateKey) { 
                                roomBook.push({
                                    name: room.name,
                                    board: rateSelect.boardName 
                                }); 
                            } 
                        } 
                    }
                }
                let roomDetalForEmail = '';
                for (let roombk of roomBook) {

                    roomDetalForEmail += `<p>${roombk.name} (${roombk.board})</p>`;
                }
                let occupancies = '';
                let roomNo = 0;
                for (let occupancie of this.state.occupancies) {
                    roomNo++;
                    occupancies += `<p>Room ${roomNo}, Number of adults: ${occupancie.adults}, Number of children: ${occupancie.children}  </p> `;

                }

                let nameSender = d.name;
                let contentClient = "";
                contentClient = "<h3>Thank you for booking your Bali hotel with Bali Hotels and More!</h3>";
                contentClient += `<p>You&rsquo;ve made a great choice; we&rsquo;re with you every step of the way to ensure hassle free holiday planning and that you have a great time in Bali. You&rsquo;ve chosen the Book Now and Pay Later option - this is a great way of making your holiday more affordable. You&rsquo;ll avoid the hidden costs of banking fees and poor currency exchange rates which you can add 5 - 10% to the cost of your accommodation when you pay with your card at the hotel. The Book Now and Pay Monthly option which you&rsquo;ve chosen includes a $1 deposit and then final payment is due 2 weeks prior to arrival in Bali or before the cancellation date of the hotel you have chosen Full terms and conditions are here &nbsp;<a href="https://www.balihotelsandmore.com/terms-of-use" target="_blank">https://www.balihotelsandmore.com/terms-of-use</a></p>`;
                contentClient += "<p>Our team will now check to ensure we have the option available for the room you want. We will then give you a quick call to confirm your exact requirements. Then we send an invoice for $1 deposit. Once you pay then we then issue and email your hotel vouchers.</p>";                
                contentClient += "<p>We would also like to take this opportunity to thank you on behalf of our Bali charities we support including:</p>";                
                contentClient += `<p>Soleman Bali - &nbsp;<a href="https://www.solemen.org/">https://www.solemen.org</a> &nbsp;</p>`;                
                contentClient += `<p>Stella&rsquo;s Child - <a href="https://www.stellaschild.org/">https://www.stellaschild.org/</a></p>`;                
                contentClient += "<p>Your booking really does make a difference here in Bali!</p>";                
                contentClient += "<p>We look forward to speaking to you within the next 24 - 48 hours.</p>"; 
                let contentAdmin = "";
                contentAdmin += `Name : ${d.name} <br>`;
                contentAdmin += `email : ${d.email} <br>`;
                contentAdmin += `phoneNumber : ${d.phoneNumber} <br>`;
                contentAdmin += `country : ${d.country} <br><br><br>`;
                contentAdmin += `hotelName : ${d.hotelName} <br><br>`;
                contentAdmin += `Room Detail `;
                contentAdmin += `${roomDetalForEmail}`;
                contentAdmin += `occupancies `;
                contentAdmin += `${occupancies}`;
                contentAdmin += `address : ${d.address} <br>`;
                contentAdmin += `settlement :  manual plan <br>`;
                contentAdmin += `checkIn : ${momentWrapper(d.checkIn).format("MMM Do YYYY")} <br>`;
                contentAdmin += `checkOut : ${momentWrapper(d.checkOut).format("MMM Do YYYY")} <br>`;
                contentAdmin += `Coupon Code : ${this.state.couponCode} <br>`; 
                let subject = "$1 Deposit Booking Request";
                let emailSender = d.email;

                let dataSendEmail = {
                    nameSender: nameSender,
                    contentClient: (contentClient),
                    contentAdmin: (contentAdmin),
                    emailSender: emailSender,
                    subject: subject
                };
                getAjaxhelper().post("/dynamics/email-sender-bham/enquery", dataSendEmail).then(
                    x => {
                        this.props.history.push('/settlement-thankyou');
                    }
                ).catch(
                    exc => {
                        console.log(exc);
                    }
                );
            }
        ).catch(
            exc => {
                console.log(exc);
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/hotels/HotelSattlementEnquiry.tsx